import * as React from "react";

import { cn } from "~app/lib/utils";

const Textarea = React.forwardRef<
  HTMLTextAreaElement,
  React.ComponentProps<"textarea">
>(({ className, ...props }, ref) => {
  return (
    <textarea
      data-slot="textarea"
      className={cn(
        "border-input placeholder:text-muted-foreground focus-visible:border-[var(--yield-celery)] focus-visible:ring-[rgba(157,193,129,0.2)] aria-invalid:border-[var(--form-error)] aria-invalid:ring-[rgba(183,73,93,0.18)] dark:aria-invalid:ring-[rgba(183,73,93,0.24)] dark:bg-input/30 flex field-sizing-content min-h-16 w-full rounded-md border bg-transparent px-3 py-2 text-base shadow-xs transition-[color,box-shadow] outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        className
      )}
      ref={ref}
      {...props}
    />
  );
});

Textarea.displayName = "Textarea";

export { Textarea };
